/** HTTP recovery must never replace a newer socket or SFU membership update. */
export function createRosterGate<T>(apply:(value:T)=>void){
 let revision=0,active=true;
 return {
  invalidate(){revision++},
  publish(value:T){if(active){revision++;apply(value)}},
  async recover(load:()=>Promise<T>){const ticket=++revision;const value=await load();if(active&&ticket===revision)apply(value)},
  close(){active=false;revision++}
 };
}
